import { useState } from "react";
import ToggleSwitch from "../../ui/toggleSwitch/ToggleSwitch";

const PermissionsSelector = ({
  permissions,
  selectedPermissions,
  onChange,
}) => {
  const [state, setState] = useState(
    permissions.reduce((acc, permission) => {
      acc[permission.id] = selectedPermissions.includes(permission.id);
      return acc;
    }, {})
  );

  const handleToggle = (id) => {
    const updatedState = { ...state, [id]: !state[id] };
    setState(updatedState);

    // Llamar al onChange para informar los permisos seleccionados
    const activePermissions = Object.keys(updatedState).filter(
      (key) => updatedState[key]
    );
    onChange(activePermissions);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {permissions.map((permission) => (
        <div
          key={permission.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            color: "#6c757d",
            fontSize: "14px",
            background: "white",
            minWidth: "500px",
          }}
        >
          <span>{permission.nombre}</span>

          <ToggleSwitch
            isOn={state[permission.id]}
            setIsOn={() => handleToggle(permission.id)}
            name={permission.id}
            onChange={() => {}}
          />
        </div>
      ))}
    </div>
  );
};

export default PermissionsSelector;
